import { jsx } from "react/jsx-runtime";
import { TextField } from "@mui/material";
import cn from "../../vendor/classnames/index.js";
import { memo } from "react";
import { mapRowSizes, mapSizes } from "./constanst.js";
import { textareaStyles } from "./styles.js";
const Textarea = memo(
  ({
    error,
    readOnly,
    className,
    size = "md",
    minRows,
    maxRows,
    fixedRowsCount = !1,
    ...restProps
  }) => {
    const maxRowsComputed = readOnly ? void 0 : fixedRowsCount ? mapRowSizes[size] : maxRows;
    return /* @__PURE__ */ jsx(
      TextField,
      {
        sx: textareaStyles,
        focused: readOnly ? !1 : void 0,
        spellCheck: !readOnly,
        error: !!error,
        multiline: !0,
        minRows: readOnly ? void 0 : minRows || mapRowSizes[size],
        maxRows: maxRowsComputed,
        color: "secondary",
        size: mapSizes[size],
        className: cn(
          { "editor-error": !!error, "editor-readonly": readOnly },
          className
        ),
        ...restProps
      }
    );
  }
);
Textarea.displayName = "Editor";
export {
  Textarea
};
//# sourceMappingURL=Textarea.js.map
